<template>
  <div class="comments">
    <div ref="comments" class="p-3" style="overflow-x: hidden;">
      <Comment
        v-for="comment in comments"
        :key="comment.id"
        :id-comment="comment.id"
        :created-at="comment.created_at"
        :user-id="comment.creator_user_id"
        :text="comment.comment"
        :bookmarked="comment.bookmarked"
        :parent_comment="comment.parent_comment"
        :files="comment.files"
        :isCanMarkMessages="true"
        :author-edit-seconds-left="comment.author_edit_seconds_left || 0"
        class="comment"
        @editComment="editComment(comment)"
        @replyComment="replyComment(comment)"
        @remove="removeComment"
        @makeBookmarked="makeBookmarked"
        @scrollToRepliedComment="scrollToRepliedComment"
      />
    </div>
    <CommentSubmitForm
      class="submit-form"
      no-focus
      :needFileUploadButton="true"
      :loading="savingComment"
      :id-comment="idComment"
      :is-reply="isReply"
      :text="text"
      :old-value="oldValue"
      :is-need-to-refresh="isNeedToRefresh"
      :is-can-mark-messages="true"
      @addFiles="addFiles"
      @submit="submitComment"
      @cancelReplyOrEdit="cancelReplyOrEdit"
      @setReplyComment="setReplyComment"
      @setEditComment="setEditComment"
      @refreshed="refreshed"
    />
  </div>
</template>

<script>
import Comment from "@components/comments/Comment.vue";
import CommentSubmitForm from "@components/comments/CommentSubmitForm";
import { mixinComments } from "@/mixins/mixinComments";

export default {
  mixins: [mixinComments],

  props: {
    companyId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      comments: [],
      files: [],
      savingComment: false,
      apiName: 'companies',
      idName: 'company_id',
      firstLoad: true,
      editCommentStatus: false,
    };
  },

  components: {
    Comment,
    CommentSubmitForm,
  },

  watch: {
    comments: {
      handler() {
        if (this.editCommentStatus) return;
        this.$nextTick(() => {
          this.firstLoad ? this.scroll("auto") : this.scroll("smooth");
          this.firstLoad = false;
        });
      },
      immediate: true,
    },
  },

  computed: {
    currentId() {
      return this.companyId;
    }
  },

  methods: {
    async fetchComments() {
      this.comments = await this.$api.companies.getComments(this.companyId);
      this.$emit("update", this.comments);
    },

    removeComment(id) {
      this.editCommentStatus = true;
      this.$api.companies.removeComment(id).then(() => {
        this.fetchComments();
        setTimeout(() => {
          this.editCommentStatus = false;
        }, 500);
      }).catch(() => {
        // Ошибку (например, истекло время на удаление) показывает axios-интерцептор
        this.editCommentStatus = false;
        this.fetchComments();
      });
    },

    makeBookmarked(params) {
      this.$api.companies.makeBookmarked(params).then(() => {
        this.fetchComments();
      });
    },

    scroll(smooth) {
      this.$refs.comments.scrollTo({
        top: this.$refs.comments.scrollHeight,
        behavior: smooth,
      });
    },
  },

  async mounted() {
    this.fetchComments();
  },
};
</script>

<style lang="scss" scoped>
.comment {
  margin-bottom: 10px;
  min-width: 400px;
  background-color: #e9e9e9;
}
.comments {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.submit-form {
  margin-bottom: 0;
  margin-top: auto;
}
</style>
